
import * as z from "zod";
import { validatePhoneNumber, validateEmail } from "@/utils/sanitization";

export const AdvertiseFormSchema = z.object({
  businessName: z.string()
    .min(2, "Business name is required")
    .max(100, "Business name must be less than 100 characters"),
  contactName: z.string()
    .min(2, "Contact name is required")
    .max(100, "Contact name must be less than 100 characters"),
  email: z.string()
    .min(1, "Email is required")
    .email("Please enter a valid email address")
    .refine(validateEmail, "Please enter a valid email address"),
  phone: z.string()
    .min(1, "Phone number is required")
    .refine(validatePhoneNumber, "Please enter a valid phone number"),
  message: z.string()
    .max(500, "Message must be less than 500 characters")
    .optional(),
});

export type AdvertiseFormValues = z.infer<typeof AdvertiseFormSchema>;
